/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SET_SELECTED_SUBENTERPRISE, GET_SUBENTERPRISES, SET_FILTERED_SUBENTERPRISES, SET_ENTITLEMENTS_FOR_SUBENTERPRISE, RESET_SUBENTERPRISES } from "./types";

const initialState = {
  subEnterprises: [],
  filteredSubEnterprises: [],
  selectedSubEnterprise: {
    entitlements: []
  },
  noSubEnterprise: false,
};

export const subEnterpriseReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_SUBENTERPRISES:
      return {
        ...state,
        subEnterprises: action.subEnterprises,
        selectedSubEnterprise: action.selectedSubEnterprise,
        noSubEnterprise: action.noSubEnterprise,
      };
    case SET_FILTERED_SUBENTERPRISES:
      return {
        ...state,
        filteredSubEnterprises: action.filteredSubEnterprises,
      };
    case SET_SELECTED_SUBENTERPRISE:
      return {
        ...state,
        selectedSubEnterprise: action.selectedSubEnterprise,
      };
    case SET_ENTITLEMENTS_FOR_SUBENTERPRISE:
      return {
        ...state,
        selectedSubEnterprise: {
          ...state.selectedSubEnterprise,
          entitlements: action.entitlements,
        },
      };
    case RESET_SUBENTERPRISES:
      return {
        ...state,
        subEnterprises: [],
        selectedSubEnterprise: {},
        noSubEnterprise: false,
      };
    default:
      return state;
  }
};
